import { render, staticRenderFns } from "./SelectGiveAwayProduct.vue?vue&type=template&id=46e9123c&scoped=true&"
import script from "./SelectGiveAwayProduct.vue?vue&type=script&lang=js&"
export * from "./SelectGiveAwayProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9123c",
  null
  
)

export default component.exports